import {
  MDBBadge,
  MDBBtn,
  MDBChip,
  MDBCol,
  MDBIcon,
  MDBInput,
  MDBInputGroup,
  MDBRating,
  MDBRatingElement,
  MDBRow,
  MDBTypography,
} from 'mdb-react-ui-kit';
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { MiscContext } from '../context/MiscProvider';
import { NavbarContext } from '../context/NavProvider';
import { useTruncateToggle } from '../utils/Common';
import LinkOpenModal from '../utils/LinkOpenModal';

function Details({ item, createCart, weight, setWeight, qty, setQty, reviews, firstDescription }) {
  const { addedEntities } = useContext(MiscContext);
  const { business, isPricing } = useContext(NavbarContext);
  const detailDescriptionsTrunc = useTruncateToggle();

  const renderParagraphs = (paragraphs, level = 0) => {
    if (!paragraphs || paragraphs.length === 0) return null;
  
    return (
      <div style={{ paddingLeft: `${level * 20}px` }}>
        {paragraphs.map((paragraph, index) => (
          <div key={`${index}-${level}`} className="paragraph-section text-start">
           
  
            <p className="mt-1 ms-2 text-start text-black">
              {paragraph.type === 'link' ? (
                <a href={paragraph.textValue} target="_blank" rel="noopener noreferrer">
                  <MDBBtn color="link" rippleColor="dark" className="text-start text-lowercase">
                    {paragraph.textValue}
                  </MDBBtn>
                </a>
              ) : paragraph.type==='caption' ? 
              <MDBBadge pill color='danger' light className='mx-2 rounded-4 d-flex align-items-center justify-content-center'>
              <figure className="mb-0 d-flex flex-column align-items-center text-center">
                <MDBTypography blockquote> 
                  <p className={`${paragraph.heading?.textColor || 'text-dark'} fw-bold mb-0 text-capitalize`}>
                    {paragraph.heading?.textValue}
                  </p>
                </MDBTypography>
                <figcaption className="blockquote-footer mb-0">
                  <cite className={`${paragraph?.textColor || 'text-dark'} fw-bold mb-0`} title="Source Title">
                    {paragraph.textValue}
                  </cite>
                </figcaption>
              </figure>
            </MDBBadge>
            :
               paragraph.heading?.textValue && (
                <MDBTypography
                  variant={paragraph.heading?.textSize || 'fs-5'}
                  className={`${paragraph.heading?.textColor || 'text-dark'} text-start mb-0`}
                  style={{ color: paragraph.heading?.textColor }}
                >
                  {paragraph.heading.textValue}
                </MDBTypography>
              )}
            </p>
  
            {/* Recursively render sub-paragraphs if they exist */}
            {renderParagraphs(paragraph.paragraphs, level + 1)}
          </div>
        ))}
      </div>
    );
  };
  

  // Render first description with paragraphs
  const renderFirstDescription = () => {
    if (!firstDescription) return null;

    if (firstDescription.type === 'caption') {
      return (
        <MDBBadge light='true' className='p-3 badge-primary rounded-4'>
       
        <figure className="mb-0">
          <MDBTypography blockquote> 
            <p className={`${firstDescription.heading?.textColor || 'text-dark'} fw-bold mb-1 text-capitalize`}>{firstDescription.heading?.textValue}</p>
          </MDBTypography>
          <figcaption className="blockquote-footer mb-2">
            <cite className={`${firstDescription?.textColor || 'text-dark'} fw-bold mb-1`} title="Source Title">{firstDescription.textValue}</cite>
          </figcaption>
        </figure>
      
        </MDBBadge>
      );
    } else {
      return (
        <div className="description-block">
          {firstDescription.heading?.textValue && (
     
            <MDBTypography tag= {`${firstDescription.heading?.textSize || 'h4'}`}
              variant= {`${firstDescription.heading?.textSize || 'h4'}`}
              className={`description-heading ${firstDescription.heading?.textColor || 'text-dark text-capitalize'}`}
              style={{ color: firstDescription.heading?.textColor }}
            >
              {firstDescription.heading?.textValue}
            </MDBTypography>
           
          )}

          {firstDescription.textValue && (
            <p
              className={detailDescriptionsTrunc.isExpanded ? 'mt-3 text-start text-black' : 'truncate mt-3 text-start text-black'}
            >
              {firstDescription.type === 'link' ? (
                <div className="align-items-center justify-content-center mb-0">
                  <LinkOpenModal
                    url={firstDescription.textValue}
                    label={firstDescription.heading.textValue}
                    isOpen={false}
                    toggleOpen={() => {}}
                    setIsOpen={() => {}}
                  />
                </div>
              ) : (
                firstDescription.type === "caption" ? 
                <MDBChip size="md" className='align-items-center text-center justify-content-center' >
       {firstDescription.heading?.image &&  <img src={firstDescription.heading?.image} alt='https://opengrit.com/images/aum' />}
                  <figure className="mb-0">
          <MDBTypography blockquote tag= {`${firstDescription.heading?.textSize || 'h4'}`}>
            <p className='text-capitalize mb-1' >{firstDescription.heading?.textValue}</p>
          </MDBTypography>
          <figcaption className="blockquote-footer mt-0">
            <cite title="Source Title" className={`${firstDescription?.textColor || 'text-success'} fw-bold`}>{firstDescription.textValue}</cite>
          </figcaption>
        </figure>
        </MDBChip>:

                firstDescription.textValue
              )}
            </p>
          )}

          {/* Render paragraphs for the first description */}
          {renderParagraphs(firstDescription.paragraphs)}
        </div>
      );
    }
  };

  return (
    <MDBCol>
      <div className="d-grid gap-2 mx-auto">
        {item?.caption ? 
                <MDBChip size="md" className='align-items-center text-center justify-content-center'>
       {item?.image &&  <img src={item?.image} alt='' />}
          <figure className="mb-0">
            <MDBTypography tag="h1" variant="h5" className="fw-bold">
              <p>{item?.name}</p>
            </MDBTypography>
            <figcaption className="blockquote-footer mb-0">
              <cite title="Source Title">{item.caption}</cite>
            </figcaption>
          </figure>
          </MDBChip>
        
        
         : 
          <MDBTypography tag="h1" variant="h5" className="fw-bold mb-1">
            {item?.name}
          </MDBTypography>
        }

        <MDBRating className="justify-content-center" value={reviews?.avgRate}>
          <MDBRatingElement itemId={1} icon="star" />
          <MDBRatingElement itemId={2} icon="star" />
          <MDBRatingElement itemId={3} icon="star" />
          <MDBRatingElement itemId={4} icon="star" />
          <MDBRatingElement itemId={5} icon="star" />
        </MDBRating>

        {business === 'B2C' && (
          <h5 className="mb-2">
            {item?.discountedPrice === 0 ? (
              <span className="text-muted me-2 small align-middle">
                {item?.currencySymbol}
                {item?.originalPrice}
              </span>
            ) : (
              <s className="text-muted me-2 small align-middle">
                {item?.currencySymbol}
                {item?.originalPrice}
              </s>
            )}
            {item?.discountedPrice !== 0 && (
              <span className="align-middle">
                {item?.currencySymbol}
                {item?.discountedPrice}
              </span>
            )}
          </h5>
        )}

        {/* Render the first description */}
        {renderFirstDescription()}

        {detailDescriptionsTrunc.isTruncated && (
          <MDBBtn
            size="sm"
            color="link"
            onClick={detailDescriptionsTrunc.toggleExpanded}
            className="text-lowercase"
            type="button"
          >
            {detailDescriptionsTrunc.isExpanded ? 'Show Less' : 'Show More'}
          </MDBBtn>
        )}

        {business === 'B2C' && (
          <>
            <div className="overflow-hidden">
              {ItemMeasurements(weight, item?.id, item, setWeight, qty, setQty, isPricing)}
            </div>

            <hr className="my-2" />

            <div className="d-grid gap-4 mx-auto d-flex">
              <MDBBtn rounded color="primary" onClick={() => createCart(item, item.id)}>
                <MDBIcon
                  fas
                  icon={addedEntities instanceof Set && addedEntities.has(item?.id) ? 'cart-plus' : 'shopping-cart'}
                />
                {addedEntities instanceof Set && addedEntities.has(item?.id) ? 'update' : 'add'}
              </MDBBtn>

              <MDBBtn floating color="danger" data-mdb-toggle="tooltip" title="Add to wishlist">
                <MDBIcon fas icon="heart" />
              </MDBBtn>
            </div>
          </>
        )}
      </div>
    </MDBCol>
  );
}

Details.propTypes = {
  item: PropTypes.object,
  createCart: PropTypes.func,
  weight: PropTypes.string,
  qty: PropTypes.string,
  setWeight: PropTypes.func,
  setQty: PropTypes.func,
  reviews: PropTypes.object,
  firstDescription: PropTypes.object, // Add firstDescription as a prop
};

export default Details;

function ItemMeasurements(weight, index, item, setWeight, qty, setQty, isPricing) {
  return (
    <MDBRow className="justify-content-center">
      <MDBInputGroup className="w-100 justify-content-center  rounded">
        {!isPricing && (
          <MDBCol xs="6" sm="6" md="6" className="d-flex align-items-center">
            <MDBInput
              label="Wt"
              name="Weight"
              id="typeNumber"
              type="number"
              min="0.25"
              step={0.25}
              value={(weight && weight[index]) || item?.weight || 1}
              onChange={(e) => setWeight((prev) => ({ ...prev, [index]: parseFloat(e.target.value) }))}
              outline
            />
            <div>
              <MDBBtn
                className="rounded"
                color="link"
                size="sm"
                onClick={() =>
                  setWeight((prev) => ({
                    ...prev,
                    [index]: Math.max((prev[index] || item?.weight || 1) + 0.25, 0.25),
                  }))
                }
              >
                +
              </MDBBtn>
              <MDBBtn
                className="rounded"
                color="link"
                size="sm"
                onClick={() =>
                  setWeight((prev) => ({
                    ...prev,
                    [index]: Math.max((prev[index] || item?.weight || 1) - 0.25, 0.25),
                  }))
                }
              >
                -
              </MDBBtn>
            </div>
          </MDBCol>
        )}

        <MDBCol xs="6" sm="6" md="6" className="d-flex align-items-center rounded">
          <MDBInput
            label="Qty"
            name="Qty"
            id="typeNumber"
            type="number"
            min="1"
            value={(qty && qty[index]) || item?.qty || 1}
            onChange={(e) => setQty((prev) => ({ ...prev, [index]: parseInt(e.target.value, 10) }))}
            outline
          />
          <div>
            <MDBBtn
              className="rounded"
              color="link"
              size="sm"
              onClick={() => setQty((prev) => ({ ...prev, [index]: (prev[index] || item?.qty || 1) + 1 }))}
            >
              +
            </MDBBtn>
            <MDBBtn
              className="rounded"
              color="link"
              size="sm"
              onClick={() => setQty((prev) => ({ ...prev, [index]: Math.max((prev[index] || item?.qty || 1) - 1, 1) }))}
            >
              -
            </MDBBtn>
          </div>
        </MDBCol>
      </MDBInputGroup>
    </MDBRow>
  );
}
